const choices = {
    free: 'Libre',
    clause: 'Clause Type',
};

export default choices;
